<div class="container-border">
  <microsec-loading-overlay [isLoading]="!!isLoading">
    <microsec-selected-panel-header
      [id]="zone.id"
      [label]="zone.label"
      (closeSelectedPanelEvent)="hideDetailsEvent.emit()"
      [rightTemplate]="rightTemplate" />
    <ng-template #rightTemplate>
      @if (!!permissions[USER_ROLE.TECHNICIAN]) {
        <div [pTooltip]="!isValidLicense() ? INACTIVE_LICENSE : ''" tooltipPosition="bottom" appendTo="body">
          <p-button
            severity="primary"
            icon="fas fa-edit"
            pTooltip="Edit"
            tooltipPosition="bottom"
            appendTo="body"
            (onClick)="openFormEvent.emit(zone)"
            [disabled]="!isValidLicense()" />
        </div>
      }
    </ng-template>
    <microsec-card [isDetailCard]="true">
      <p-tabs class="microsec-dashboard-tab" [value]="0">
        <p-tablist>
          <p-tab [value]="0">Overview</p-tab>
          <p-tab [value]="1">Compliance</p-tab>
          <p-tab [value]="2">Devices</p-tab>
          <p-tab [value]="3">Attachments</p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel [value]="0">
            <app-zone-overview [zone]="zone" />
          </p-tabpanel>
          <p-tabpanel [value]="1">
            <app-zone-compliance [zone]="zone" />
          </p-tabpanel>
          <p-tabpanel [value]="2">
            <app-zone-devices [zone]="zone" />
          </p-tabpanel>
          <p-tabpanel [value]="3">
            <app-zone-attachments [zone]="zone" (refreshListEvent)="refreshListEvent.emit()" />
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </microsec-card>
  </microsec-loading-overlay>
</div>
